export enum MessageTypesEnum {
    SMS,
    EMAIL
}